<template>
  <ion-page>
    <ion-content class="zwischenseite">
      <ion-grid>
        <ion-row>
          <ion-col class="btn-back" mode="ios">
            <ion-button href="/home">{{ $t('general.back') }}</ion-button>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <p>
              {{ $t('intermediatePage.hint.content.first') }}<br>
              {{ $t('intermediatePage.hint.content.second') }}
            </p>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="4" class="helpPictureWrapper">
            <img src="assets/pix/content/help-button.jpg">
          </ion-col>
          <ion-col size="7" class="helpTextWrapper">
            <h3>{{ $t('intermediatePage.headline') }}</h3>
            <a :href="'mailto:' + $t('intermediatePage.email')">
              {{ $t('intermediatePage.email') }}
            </a><br><br>
            <a :href="'tel:' + $t('intermediatePage.telephone')">{{ $t('intermediatePage.telephone') }}</a>
          </ion-col>
        </ion-row>
        <ion-col>
          <div class="btn-primary btn-big" mode="ios">
            <ion-button class="button-round" expand="full" href="/home">
              {{ $t('intermediatePage.backToStart') }}
            </ion-button>
          </div>
        </ion-col>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonContent, IonPage, IonGrid, IonRow, IonCol } from '@ionic/vue';
import { defineComponent } from 'vue';
import { useRouter} from "vue-router";
import {store} from "@/store/formtemplate";
import {productsstore} from "@/store/products";


export default defineComponent({
  name: 'Zwischenseite',
  setup() {
    return {
      router: useRouter()
    }
  },
  components: {
    IonContent,
    IonGrid,
    IonRow,
    IonCol,
    IonPage
  },
  methods: {
    resetFormTemplate: function () {
        this.$router.push("/verbindungsart").then(function () {
          store.dispatch("resetStore");
        });
      },
  },
});

</script>
